import Env from 'enviro';
import { getProxyApiUrl } from 'in-meeting-experience-ui-components/utils/general';
import { CLOUD_PROJECT_NUMBER } from '../../constants/google-meet';
import { getGoogleParticipantsResponse, getSpaceMockResponse, getConferenceRecordMockResponse } from '../../mocks/googleApi';
import noAuthClient from '../../utils/apiClient';
import { isIframe } from '../../utils/general';
const API_BASE = `${getProxyApiUrl()}/googlemeet/add-on`;
export const createAddonSession = () =>
// @ts-expect-error Property 'meet' does not exist on type 'Window & typeof globalThis'.
window.meet.addon.createAddonSession({
  cloudProjectNumber: Env.isQa() ? CLOUD_PROJECT_NUMBER.qa : CLOUD_PROJECT_NUMBER.prod
});
export const getMeetingSpace = spaceName => isIframe ? noAuthClient.get(`${API_BASE}/spaces/${spaceName}`) : Promise.resolve(getSpaceMockResponse());
export const getParticipants = (conferenceRecordId, setSkipRefresh) => isIframe ? noAuthClient.get(`${API_BASE}/conference-records/${conferenceRecordId}/participants`, {
  setSkipRefresh
}) : Promise.resolve(getGoogleParticipantsResponse());
export const getConferenceRecord = conferenceRecordId => isIframe ? noAuthClient.get(`${API_BASE}/conference-records/${conferenceRecordId}`) : Promise.resolve(getConferenceRecordMockResponse());